(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oh-content-page"] && !Shopify.designMode) return;
  try {
    
  function initializeOhPolicy(root) {
    const policies = root.matches?.('[data-oh-policy]') ? [root] : root.querySelectorAll('[data-oh-policy]');
    for (const policy of policies) {
      const toc = policy.querySelector('[data-policy-toc]');
      const links = policy.querySelector('[data-policy-toc-links]');
      const headings = policy.querySelectorAll('[data-policy-body] h2');
      if (!toc || !links) continue;
      links.replaceChildren();
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = 'oh-policy-' + policy.dataset.policyId + '-' + (index + 1);
        const link = document.createElement('a');
        link.href = '#' + encodeURIComponent(heading.id);
        link.textContent = heading.textContent;
        links.append(link);
      });
      toc.hidden = headings.length === 0;
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeOhPolicy(document), {once: true});
  } else {
    initializeOhPolicy(document);
  }
  document.addEventListener('shopify:section:load', event => initializeOhPolicy(event.target));

  } catch(e) { console.error(e); }
})();
})();
